/** Wallboard ng supervisor (M29 Phase 2): mga tile at ang board ng mga agent. Shell created by WP-M29-SCHEMA2: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const wallboard = {
  tiles: {
    group: "Mga live na bilang",
    queue: "Nasa pila",
    queueHint: "Mga chat na naghihintay ng tao",
    breakdownTeams: "Ayon sa team",
    breakdownTiers: "Ayon sa tier",
    noTeam: "Walang team",
    noTier: "Walang tier",
    longestWait: "Pinakamatagal na paghihintay",
    longestWaitNone: "Walang naghihintay",
    priorityWaiting: "Priority na naghihintay",
    priorityWaitingHint: "Mga high o urgent na chat na wala pang humahawak",
    agentsOnline: "Mga agent na online",
    agentsOnlineHint: "Online, mula sa lahat ng puwedeng tumanggap ng chat",
    atLimit: "Abot na sa limit",
    atLimitHint: "Mga agent na hawak na ang pinakamaraming chat na pinapayagan",
    slasAtRisk: "Mga SLA na nanganganib",
    slasAtRiskHint: "Late na, o due sa loob ng {{minutes}} minuto",
    safetyCases: "Bukas na safety case",
    safetyCasesHint: "Mga required na handover na nauuna sa lahat ng tier, naghihintay man o hawak na",
    needsAttention: "Kailangan ng pansin",
  },
  board: {
    title: "Wallboard",
    subtitle: "Ang pila at ang mga agent ninyo, live.",
    live: "Live",
    liveUpdated: "Live, na-update {{seconds}} s na ang nakalipas",
    polling: "Nagre-refresh bawat {{seconds}} s",
    connecting: "Kumokonekta",
    reconnecting: "Muling kumokonekta, nagre-refresh bawat {{seconds}} s",
    stale: "Huling update {{seconds}} s na ang nakalipas",
    loading: "Nilo-load ang wallboard",
    errorTitle: "Hindi ma-load ang wallboard",
    errorBody: "Hindi namin nabasa ang mga live na bilang. Suriin ang koneksyon at subukan muli.",
    retry: "Subukan muli",
    offTitle: "Hindi pa naka-on ang live chat operations",
    offBody: "Lalabas ang pila at ang mga agent sa wallboard kapag naka-on na ang live chat operations para sa workspace na ito. Humiling sa may-ari ng platform na i-on ito.",
    offAction: "Bumalik sa inbox",
    agents: {
      title: "Mga agent ngayon",
      subtitle: "Ang dami ng hawak laban sa limit ng bawat isa.",
      tableLabel: "Mga agent at ang hawak nilang chat",
      agent: "Agent",
      status: "Status",
      load: "Hawak",
      longest: "Pinakamatagal na chat",
      actions: "Mga aksyon",
      loadText: "{{active}} sa {{limit}}",
      loadLabel: "{{name}}: {{active}} sa {{limit}} na chat",
      atLimit: "Abot na sa limit",
      none: "Wala",
      emptyTitle: "Wala pang agent na maipapakita",
      emptyBody: "Dito lalabas ang mga taong may role na puwedeng sumagot ng chat, kasama ang status at mga hawak nilang chat.",
      emptyAction: "Buksan ang team",
      teams: "Mga team: {{teams}}",
    },
    waiting: {
      title: "Naghihintay ngayon",
      subtitle: "Safety case muna, saka ayon sa priority at tagal.",
      listLabel: "Mga chat na naghihintay ng tao",
      waited: "naghihintay nang {{time}}",
      more: "{{count}} pa ang naghihintay",
      safety: "Safety case",
      priorityUrgent: "Urgent",
      priorityHigh: "High",
      emptyTitle: "Walang naghihintay",
      emptyBody: "Dito lalabas ang mga chat na humihingi ng tao hanggang may kumuha na agent.",
      untitled: "Chat",
      assign: "Italaga",
      assignLabel: "Italaga ang chat na \"{{title}}\"",
    },
    reassign: {
      button: "Ilipat",
      buttonLabel: "Maglipat ng chat na hawak ni {{name}}",
      title: "Ilipat ang chat kay",
      forChat: "Chat: {{title}}",
      pickChat: "Pumili ng chat ni {{name}}",
      noChats: "Walang hawak na chat si {{name}} na makikita ninyo.",
      chatHeld: "hawak nang {{time}}",
      noRoom: "Abot na sa limit",
      offline: "Offline",
      you: "Ikaw",
      noTargets: "Wala nang ibang makakatanggap nito ngayon.",
      done: "Nailipat kay {{name}}",
      alreadyThere: "Hawak na ni {{name}} ang chat na ito",
      failed: "Hindi nailipat ang chat",
      full: "Abot na sa chat limit si {{name}}",
      gone: "Hindi na naghihintay o hawak ang chat na iyon",
    },
    status: {
      autoAway: "Away (walang aktibidad)",
    },
  },
};
